import axios from "axios"
import { FiShare2 } from "react-icons/fi"
import { BACKEND } from "../config/configEnvs"
import { useEffect, useRef, useState } from "react"
import Pagination from '@mui/material/Pagination';
import { FaFileExcel, FaFilePdf, FaInfoCircle, FaLink, FaMinus, FaNetworkWired, FaSpinner, FaTimes, FaYoutube } from "react-icons/fa";
import { toast } from "react-toastify";
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import * as React from 'react';
import { useSelector } from "react-redux";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';
import { FaAngleUp, FaAngleDown } from "react-icons/fa6";
import Tooltip from "../components/ui/ToolTip";
import { SiCanva } from "react-icons/si";
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";
import PaginationItem from "../components/ui/components/Pagination";
import { CaracteristicasAdicionales, CaracteristicasAdicionalesBasico, CaracteristicasAdicionalesIntermedio, CaracteristicasAulaVirtual, CaracteristicasAulaVirtualBasico, CaracteristicasAulaVirtualIntermedio, CaracteristicasTiendaVirtual, CaracteristicasTiendaVirtualBasico, CaracteristicasTiendaVirtualIntermedio, CaracteristicasWebInformativa, CaracteristicasWebInformativaBasica, CaracteristicasWebInformativaIntermedia } from "../utils/plainValues/CaracteristicasServicios";
import Selector from "../components/ui/components/Selector";
import { Limits10_50 } from "../utils/plainValues/DefaultLimits";
import SearchBar from "../components/ui/components/SearchBar";
import DinamicButton from "../components/ui/components/DinamicButton";
import { ExportarSeleccionExcel } from "../utils/automateFuncions/ExportarColeccionExcel";



const RedesClientesWebs = () => {

  const user = useSelector((state) => state.auth.user)
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION" && (user.puesto.toUpperCase() === "ADMINISTRADOR" || user.puesto.toUpperCase() === "GERENTE GENERAL")

  const [clients, setClients] = useState([]) // Clientes

  const [loadingStatus, setLoadingStatus] = useState(false) // Estado de carga
  const [searchText, setSearchText] = useState("") // Barra de búsqueda por texto
  
  const [page, setPage] = useState(1) // Página actual
  const [limit, setLimit] = useState(55) // Límite actual

  const [totalDocs, setTotalDocs] = useState(0) // Total de documentos
  const [totalPages, setTotalPages] = useState(0) // Total de páginas

  const [productFilter, setProductFilter] = useState("") // Filtro de productos
  const [ticketFilter, setTicketFilter] = useState("") // Filtro de tickets

  // Características

  const [allChars, setAllChars] = useState([])
  const [charFilters, setCharFilters] = useState([])
  const [semiFilter, setSemifilter] = useState(["Características Aula Virtual", "Características Tienda Virtual", "Características Web Informativa", "Características Adicionales"])

  const [avChars, setAvChars] = useState(CaracteristicasAulaVirtual)
  const [tvChars, setTvChars] = useState(CaracteristicasTiendaVirtual)
  const [wiChars, setWiChars] = useState(CaracteristicasWebInformativa)
  const [caChars, setCaChars] = useState(CaracteristicasAdicionales)

  useEffect(() => {
    let newChars = [];
  
    if (semiFilter.includes("Características Aula Virtual")) {
      newChars = [...newChars, ...avChars];
    }
    if (semiFilter.includes("Características Tienda Virtual")) {
      newChars = [...newChars, ...tvChars];
    }
    if (semiFilter.includes("Características Web Informativa")) {
      newChars = [...newChars, ...wiChars];
    }
    if (semiFilter.includes("Características Adicionales")) {
      newChars = [...newChars, ...caChars];
    }
  
    setAllChars(newChars);
  }, [semiFilter, avChars, tvChars, wiChars, caChars]);

  //const characteristics = ["Certificado", "Login", "Cursos"];

  const handleSemiFilterChange = (event) => {
    const { value } = event.target;
    setSemifilter(value); // Actualiza el pre filtro
    //setCharFilters([]); // Resetea las selecciones del segundo filtro
  };
  
  const handleCharFilterChange = (event) => {
    setCharFilters(event.target.value);
  };

  const quickFilters = [
    { label: "AVB", value: CaracteristicasAulaVirtualBasico, desc: "Aula Virtual Básico" },
    { label: "AVI", value: CaracteristicasAulaVirtualIntermedio, desc: "Aula Virtual Intermedio" },
    { label: "AVA", value: CaracteristicasAulaVirtual, desc: "Aula Virtual Avanzado" },

    { label: "TVB", value: CaracteristicasTiendaVirtualBasico, desc: "Tienda Virtual Básico" },
    { label: "TVI", value: CaracteristicasTiendaVirtualIntermedio, desc: "Tienda Virtual Intermedio" },
    { label: "TVA", value: CaracteristicasTiendaVirtual, desc: "Tienda Virtual Avanzado" },
    
    { label: "WIB", value: CaracteristicasWebInformativaBasica, desc: "Web Informativa Básico" },
    { label: "WII", value: CaracteristicasWebInformativaIntermedia, desc: "Web Informativa Intermedio" },
    { label: "WIA", value: CaracteristicasWebInformativa, desc: "Web Informativa Avanzado" },

    { label: "CAB", value: CaracteristicasAdicionalesBasico, desc: "Características Adicionales Básico" },
    { label: "CAI", value: CaracteristicasAdicionalesIntermedio, desc: "Características Adicionales Intermedio" },
    { label: "CAA", value: CaracteristicasAdicionales, desc: "Características Adicionales Avanzado" },
  
  ]

  const ITEM_HEIGHT = 48;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 6.5,
        width: 200,
      },
    },
  };

  const [sortOrder, setSortOrder] = useState(null) // Ordenamiento por el precio mas bajo}

  const handleSortClick = () => {
    setSortOrder((prevOrder) => {
      if (prevOrder === "asc") return "desc";
      if (prevOrder === "desc") return null;
      return "asc";
    });
  };
  
  const [activeAgency, setActiveAgency] = useState(false) // Activo de la agencia

  const [webServices, setWebServices] = useState([])

  // Aula virtual, Super Tiendas Virtuales, Landing Page ADS y Web de informativas
  const [serviceFilters, setServiceFilters] = useState(["66168fb2e5d3e65b502e8c98", "6577752ac1c6ac85e69c86ed", "6577638bc1c6ac85e69c79cf", "657037fe132e0436ce6f5fd6"])

  const getClients = async () => { // Obtener clientes
    try {
      setLoadingStatus(true)
      let url = `${BACKEND}/api/getClientsByServiceCategory/getWebClients?limit=${limit}&page=${page}`

      if (searchText) {
        url += `&brandName=${encodeURIComponent(searchText)}`
      }

      if (activeAgency) {
        url += `&activeAgency=${activeAgency}`
      }

      if (productFilter) {
        url += `&productFilter=${productFilter}`
      }

      if (ticketFilter) {
        url += `&ticketFilter=${encodeURIComponent(ticketFilter)}`
      }

      if (sortOrder) {
        url += `&sortOrder=${sortOrder}`
      }

      const response = await axios.post(url, {
        serviceFilters: serviceFilters,
        charFilters: charFilters
      })
      setClients(response.data.clients)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)
      setLoadingStatus(false)

    } catch (error) {
      toast.error("Error al cargar los clientes: " + error)
    }
  }

  const getWebServices = async () => { // Obtener los servicios de webs
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?where[categoria][equals]=Web&limit=0`)
      setWebServices(response.data.docs)
    } catch (error) {
      console.log(error)
    }
  }

  const handlerChangeServiceFilter = (service, checked) => { // Manejador para el selector de servicios
    if (checked) {
      setServiceFilters((prev) => [...prev, service.id])
    } else {
      setServiceFilters((prev) => 
      prev.filter((serviceId) => serviceId !== service.id))
    }
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  const handleSearchClients = () => { // Funcion para buscar clientes, automáticamente lleva a la página 1
    getClients()
    setPage(1)
  }

  const handleResetSearch = () => { // Resetea la búsqueda
    setSearchText(""); // Cambiar el estado
  };

  const handleResetProductFilter = () => { // Resetea la búsqueda
    setProductFilter(""); // Cambiar el estado
  };

  useEffect(() => { // Se obtienen los clientes al cargar el componente
    getClients()
    getWebServices()
  }, [])

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (searchText === "") {
      getClients(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [searchText]);

  useEffect(() => {
    if (productFilter === "") {
      getClients(); 
      setPage(1); 
    }
  }, [productFilter]);

  useEffect(() => { 
    if (ticketFilter === "") {
      getClients(); 
      setPage(1); 
    }
  }, [ticketFilter]);

  useEffect(() => { // Se piden los clientes cada vez que se actualiza la página o el límite
    getClients()
  }, [page, limit, activeAgency, ticketFilter, sortOrder])

  useEffect(() => {
    const timeout = setTimeout(() => {
      getClients();
    }, 1500);
  
    return () => clearTimeout(timeout); // Limpia el timeout si el efecto se vuelve a ejecutar
  }, [serviceFilters, charFilters]);

  ///// Actualizar campos extras
  
  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  const handleUpdateText = (field, newValue, clientId) => { // Cambiar el texto con lógica de debouncer

    setClients((prevData) =>
      prevData.map((client) =>
        client.id === clientId
          ? {
              ...client,
              [field]: newValue,
            }
          : client
      )
    );

    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
    debounceUpdate.current = setTimeout(async () => {

      try {

        await axios.put(`${BACKEND}/api/clientesUser/${clientId}`, {
          [field]: newValue,
        });

        toast.success("Dato actualizado con éxito");
      } catch (error) {
        console.error(error);
        toast.error("Error al actualizar la fecha");
      }
    }, 1000); // Esperar 2 secs luego de que el usuario deja de ecsribir
  };

  const handleUpdateSelect = async (field, newValue, clientId) => { // Cambiar un selector, sin debouncer
    
    setClients((prevData) =>
      prevData.map((client) =>
        client.id === clientId
          ? {
              ...client,
              [field]: newValue,
            }
          : client
      )
    );

    try {
      await axios.put(`${BACKEND}/api/clientesUser/${clientId}`, {
        [field]: newValue,
      });
      toast.success("Dato actualizado con éxito");
    } catch (error) {
      console.error(error);
      toast.error("Error al actualizar la fecha");
    }
  }

  const ExportToExcel = async () => {
    const toastId = toast.loading("Exportando a Excel...")
    try {
      let url = `${BACKEND}/api/getClientsByServiceCategory/getWebClientsForExcel?limit=0`

      if (searchText) {
        url += `&brandName=${encodeURIComponent(searchText)}`
      }

      if (activeAgency) {
        url += `&activeAgency=${activeAgency}`
      }

      if (productFilter) {
        url += `&productFilter=${productFilter}`
      }

      if (ticketFilter) {
        url += `&ticketFilter=${encodeURIComponent(ticketFilter)}`
      }

      if (sortOrder) {
        url += `&sortOrder=${sortOrder}`
      }

      const response = await axios.post(url, {
        serviceFilters: serviceFilters,
        charFilters: charFilters,
        allData: true
      })

      ExportarSeleccionExcel(response.data.clients, "Clientes webs")
      toast.update(toastId, { render: "Exportación completada", type: "success", isLoading: false, autoClose: 1500 })
    } catch (e) {
      toast.update(toastId, { render: "Error: " + e, type: "error", isLoading: false, autoClose: 2500 })
    }
  }

  return (
    <div className="flex flex-col h-screen w-full">

      {/* Header */}
      <div className="flex flex-row px-6 py-2 w-full bg-gray-100 flex flex-row justify-between items-center mb-1">
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          <div className="flex items-center gap-4 py-4">
              <FaNetworkWired className="text-zinc-700 text-2xl" />
              <h2 className="text-2xl font-bold text-zinc-700">Redes clientes webs</h2>
          </div>
        </div>

        <form 
          className="flex flex-row gap-8 items-center justify-center"
          onSubmit={(e) => { e.preventDefault(); handleSearchClients()}}
        >
          {isAdmin && (
            <DinamicButton 
              backgroundColor="#2e7d32"
              hoverBackgroundColor="#1b5e20"
              content="Exportar a Excel" 
              action={ExportToExcel} 
              icon={<FaFileExcel />} 
              iconSize={14}
            />
          )}

          <Selector
            title="Límite"
            setter={setLimit}
            value={limit}
            width="w-[5rem]"
            options={Limits10_50}
          />

          <SearchBar
            value={searchText}
            setter={setSearchText}
            pageSetter={setPage}
            getter={getClients}
            placeholder="Buscar cliente"
            text="Buscar"
            disabled={loadingStatus}
          />

        </form>

      </div>
      
      {/* Web services */}     
      <div className="flex flex-row items-center bg-gray-100 mb-1 py-2 px-4">
        <div className="gap-8 w-full overflow-x-auto flex flex-row justify-between items-center">
        
          <div className="flex flex-row items-center">
            {webServices.map((service) => (
              <div
                key={service.id}
                className="flex flex-col items-center justify-center gap-1 pr-5 border-r pl-5 border-gray-300 last:pr-0 last:border-r-0"
              >
                <div className="flex flex-row items-center justify-center gap-1">
                  <span className="text-xs font-bold">{service.name}</span>
                  <input
                    type="checkbox"
                    className="rounded-md border-gray-400 hover:cursor-pointer"
                    checked={serviceFilters.includes(service.id)}
                    onChange={(e) =>
                      handlerChangeServiceFilter(service, e.target.checked)
                    }
                  />
                </div>
                <div className="flex w-full flex-row items-center px-4 justify-center pt-1 gap-4">
                  <Tooltip content="Review video">
                    <a 
                      href={service.reviewVideo || "#"}
                      target={service.reviewVideo ? "_blank" : ""}
                      rel="noopener noreferrer"
                    >
                      <FaYoutube className={`text-red-500 text-lg ${!service.reviewVideo ? "opacity-10 cursor-not-allowed" : "hover:cursor-pointer"}`}/>
                    </a>
                  </Tooltip>
                  <Tooltip content="Proyecto video">
                    <a 
                      href={service.proyectVideo || "#"}
                      target={service.proyectVideo ? "_blank" : ""}
                      rel="noopener noreferrer"
                    >
                      <FaYoutube className={`text-red-500 text-lg ${!service.proyectVideo ? "opacity-10 cursor-not-allowed" : "hover:cursor-pointer"}`}/>
                    </a>
                  </Tooltip>
                  <Tooltip content="Making off video">
                    <a
                      href={service.makingOffVideo || "#"}
                      target={service.makingOffVideo ? "_blank" : ""}
                      rel="noopener noreferrer"
                    >
                      <FaYoutube className={`text-red-500 text-lg ${!service.makingOffVideo ? "opacity-10 cursor-not-allowed" : "hover:cursor-pointer"}`}/>
                    </a>
                  </Tooltip>
                  <Tooltip content="Casos de éxito">
                    <a
                      href={service.successCaseVideo || "#"}
                      target={service.successCaseVideo ? "_blank" : ""}
                      rel="noopener noreferrer"
                    >
                      <SiCanva className={`text-sky-500 text-lg ${!service.successCaseVideo ? "opacity-10 cursor-not-allowed" : "hover:cursor-pointer"}`}/>
                    </a>
                  </Tooltip>
                  <Tooltip content="Proceso y cronograma">
                    <a 
                      href={service.processCron || "#"}
                      target={service.processCron ? "_blank" : ""}
                      rel="noopener noreferrer"
                    >
                      <SiCanva className={`text-sky-500 text-lg ${!service.processCron ? "opacity-10 cursor-not-allowed" : "hover:cursor-pointer"}`}/>
                    </a>
                  </Tooltip>
                </div>
              </div>
            ))}
          </div>

          {/* Activo agencia */}
          <div className="flex flex-row items-center justify-center gap-4">
            <span className="text-xs">Activos Agencia</span>
            <input
              type="checkbox"
              className="rounded-md border-gray-400 hover:cursor-pointer"
              checked={activeAgency}
              onChange={(e) => setActiveAgency(e.target.checked)}
            />
          </div>

        </div>
      </div>
      
      {/* Filtros de características */}
      <div className="flex flex-row items-center justify-between w-full bg-gray-100 mb-1 px-6 gap-2">

        {/* Filtro del filtro de características */}
        <div className="flex flex-row gap-8 items-center justify-center">

          <FormControl sx={{ borderRadius: "8px", height: 32, width: 300, backgroundColor: "white" }}>
            <InputLabel
              sx={{
                fontSize: 12,
                transform: "translate(14px, 6.5px) scale(1)",
                "&.MuiInputLabel-shrink": {
                  transform: "translate(14px, -6px) scale(0.75)",
                },
              }}
            >
              Filtro de opciones
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              sx={{
                height: 32,
                display: "flex",
                alignItems: "center",
                fontSize: 12,
                borderRadius: "8px",
              }}
              id="demo-multiple-checkbox"
              multiple
              value={semiFilter}
              onChange={handleSemiFilterChange}
              input={<OutlinedInput label="Filtro de opciones" sx={{ height: 25, fontSize: 12 }}/>}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={MenuProps}
            >
              {["Características Aula Virtual", "Características Tienda Virtual", "Características Web Informativa", "Características Adicionales"].map((c) => (
                <MenuItem key={c} value={c} sx={{ height: "30px" }}>
                  <Checkbox checked={semiFilter.includes(c)} />
                  <ListItemText primary={c} primaryTypographyProps={{ fontSize: 12, fontFamily: "poppins" }}/>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

        </div>

        {/* Filtro características */}
        <div className="flex flex-row gap-8 items-center justify-center">

          <FormControl sx={{ borderRadius: "8px", height: 32, width: "40vw", backgroundColor: "white" }}>
            <InputLabel
              sx={{
                fontSize: 12,
                transform: "translate(14px, 6.5px) scale(1)",
                "&.MuiInputLabel-shrink": {
                  transform: "translate(14px, -6px) scale(0.75)",
                },
              }}
            >
              Características
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              sx={{
                height: 32,
                display: "flex",
                alignItems: "center",
                fontSize: 12,
                borderRadius: "8px",
              }}
              id="demo-multiple-checkbox"
              multiple
              value={charFilters}
              onChange={handleCharFilterChange}
              input={<OutlinedInput label="Características" sx={{ height: 25, fontSize: 12 }}/>}
              renderValue={(selected) => selected.join(', ')}
              MenuProps={MenuProps}
            >
              {allChars.map((c) => (
                <MenuItem key={c} value={c} sx={{ height: "30px", width: "40vw" }}>
                  <Checkbox checked={charFilters.includes(c)} />
                  <ListItemText primary={c} primaryTypographyProps={{ fontSize: 12, fontFamily: "poppins" }}/>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

        </div>
        
        {/* Reset */}
        <Button 
          variant="contained"
          onClick={() => setCharFilters([])}
          sx={{
            fontSize: "12px",
            fontWeight: "bold",
            fontFamily: "poppins",
            padding: "4px 24px",
            backgroundColor: "#ff6400",
            transform: "all",
            animationDuration: "1000",
            textTransform: "none",
            borderRadius: "8px",
            '&:hover': {
              backgroundColor: "#bb4a03",
            }
          }}
        >
          Resetear
        </Button>

      </div>

      <div className="flex flex-row items-center justify-center w-full bg-gray-100 mt-1 mb-1 px-6 gap-2 ">
        {/* Filtros rapidos */}
        <span className="text-xs font-semibold">
          Filtros rápidos
        </span>
        <div className="flex flex-row items-center justify-center gap-1 overflow-x-auto">
          {quickFilters.map((q) => (
            <Tooltip content={q.desc}>
              <button
                onClick={() => setCharFilters(q.value)}
                className="px-4 py-0.5 bg-orange-500 rounded shadow font-bold text-[10px] text-white"
              >
                {q.label}
              </button>
            </Tooltip>
          ))}
        </div>
      </div>

      {/* Filtros */}
      {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
        <div className="flex flex-row items-center justify-between bg-gray-100 mb-1 px-6">

          {/* Filtro de ticket */}
          <div className="flex flex-row gap-8 items-center justify-center">

            <div className="w-full">
              <select
                type="text"
                placeholder="Filtrar por ticket"
                className="w-[16rem] text-xs text-gray-700 bg-white hover:cursor-pointer border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={ticketFilter}
                onChange={(e) => setTicketFilter(e.target.value)}
              >
                <option value="">Fitlrar por ticket - Todos</option>
                <option value="Bajo: -S/.500">Bajo: -S/.500</option>
                <option value="Normal: S/.800 - S/.3000">Normal: S/.800 - S/.3000</option>
                <option value="Alto: +S/.5000">Alto: +S/.5000</option>
              </select>
            </div>

          </div>

          {/* Filtro de producto */}
          <form 
            className="flex flex-row gap-8 items-center justify-center" 
            onSubmit={(e) => { e.preventDefault(); handleSearchClients()}}
          >

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Filtrar por producto o servicio"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={productFilter}
                onChange={(e) => setProductFilter(e.target.value)}
              />
              {productFilter && (
                <FaTimes
                  onClick={() => handleResetProductFilter()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button 
                variant="contained"
                type="submit"
                endIcon={<FilterAltIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
              >
                Filtrar
              </Button>
            </div>

          </form>

        </div>
      )}
      
      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <div className="flex w-full h-full text-gray-700 items-center justify-center">
            <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                <span>Cargando, por favor espera...</span>
                <FaSpinner className="animate-spin text-gray-500" />
            </div>
          </div>
        ) : (
          clients.length === 0 ? (
            <div className="flex w-full h-full text-gray-700 items-center justify-center">
              <div className="flex w-full h-full text-xs gap-2 items-center justify-center">
                  <span>No hay registros que coincidan con la búsqueda</span>
                  <FaInfoCircle className="text-gray-500" />
              </div>
            </div>
          ) : (
          
          <table className="w-full">
            <thead className="bg-white sticky top-0 z-30">
              <tr className="text-gray-700 text-center text-xs font-semibold">
                <td className="px-2 py-3 max-w-[170px] text-center bg-[#FE6400] border-r border-r-white text-white border-red sticky left-0 z-20">
                  Cliente
                </td>
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-6 py-3 text-center max-w-[200px] bg-[#FE6400] border-r border-r-white text-white border-red">
                    Tel. encargado
                  </td>
                )}
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-6 py-3 text-center max-w-[200px] bg-[#FE6400] border-r border-r-white text-white border-red">
                    Tel. gerente
                  </td>
                )}
                <td className="px-6 py-3 max-w-[200px] text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                  Nicho y rubro
                </td>
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-6 py-3 max-w-[200px] text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Datos venta
                  </td>
                )}
                <td className="px-6 py-3 max-w-[200px] text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                  Servicio
                </td>
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-6 py-3 text-center max-w-[200px] bg-[#FE6400] border-r border-r-white text-white border-red">
                    Venden
                  </td>
                )}
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-2 py-3 text-center max-w-[200px] bg-[#FE6400] border-r border-r-white text-white border-red">
                    <div className="flex flex-row items-center justify-center gap-2">
                      Precio más bajo
                      <button
                        onClick={handleSortClick}
                        className="bg-white rounded-full text-xs flex items-center justify-center h-5 w-5"
                      >
                        <IconButton aria-label="sort" size="small" className="p-0">
                          {sortOrder === "asc" && <FaAngleUp className="text-red-500 text-xs" />}
                          {sortOrder === "desc" && <FaAngleDown className="text-green-500 text-xs" />}
                          {sortOrder === null && "-"}
                        </IconButton>
                      </button>
                    </div>
                  </td>
                )}
                {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                  <td className="px-6 py-3 text-center max-w-[200px] bg-[#FE6400] border-r border-r-white text-white border-red">
                    Ticket del producto
                  </td>
                )}
                <td className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                  Link web oficial
                </td>
                <td className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                  Link Demo
                </td>
                {(user.puesto.toUpperCase() === "DESARROLLADOR FULL STACK" || user.puesto.toUpperCase() === "GERENTE GENERAL" || user.puesto.toUpperCase() === "DESARROLLADOR DE WORDPRESS Y CMS") && (
                  <td className="px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Link Drive
                  </td>
                 )}
              </tr>
            </thead>

            <tbody>
              {clients.map((client, index) => {

                const linkWebOficial = client.links.find((link) => link.titulo && link.titulo === "Link web oficial");
                const linkDemo = client.links.find((link) => link.titulo && link.titulo === "Link demo");
                const linkBackup = client.links.find((link) => link.titulo && link.titulo === "Link backup");

                return (

                  <tr
                    key={index}
                    className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100"
                  >
                    {/* Nombre marca */}
                    <td scope="row" className="px-2 py-2 max-w-[170px] border border-gray-300 truncate hover:cursor-pointer hover:underline transition-all duration-100 font-bold sticky left-0 z-[5] bg-white">
                      <a 
                        href={`/home/seguimiento/${client.id}`}
                        target="_blank" 
                        rel="noopener noreferrer"
                      >
                        {user.area?.toUpperCase() === "COMERCIAL" && user.puesto?.toUpperCase().trim() === "VENDEDOR TEMPORAL"
                          ? (client.encargadoProyecto?.split(" ")[0] || "-")
                          : client.nombreComercial
                        }
                      </a>
                    </td>

                    {/* Número encargado */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                      <td scope="row" className="px-4 py-2 max-w-[200px] border border-gray-300 truncate text-center">
                        {client?.telefono}
                      </td>
                    )}

                    {/* Número gerente */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (                    
                      <td scope="row" className="px-4 py-2 max-w-[200px] border border-gray-300 truncate text-center">
                         {client?.telefonoGerente}
                      </td>
                    )}

                    {/* Rubro y nicho */}
                    <td scope="row" className="px-4 py-2 max-w-[200px] border border-gray-300 truncate text-center">
                      {client?.nicho?.name}
                      <br />
                      {client?.nicho?.rubro?.name}
                    </td>
                    
                    {/* Datos venta */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (    
                      <td scope="row" className="px-4 py-2 max-w-[200px] border border-gray-300 truncate text-center">
                        <span className="truncate font-bold">{client?.serviceObj?.cotizacion?.cotizador?.name}</span>
                        <br />
                        <span className="truncate">          
                          {(() => {
                            const precioBase = client?.serviceObj?.customPriceActive
                              ? client?.serviceObj?.customPrice * client?.serviceObj?.numeroItems
                              : client?.serviceObj?.servicio &&
                                client?.serviceObj?.planServicio &&
                                webServices
                                  .find((e) => e.id === client?.serviceObj?.servicio.id)
                                  .preciosUnitarios.find(
                                    (ev2) => ev2.plan.id === client?.serviceObj?.planServicio.id
                                  )?.precio * client?.serviceObj?.numeroItems;

                            // Calcular el descuento
                            let montoDescuento = 0;
                            if (client?.serviceObj?.tipoDescuento === "Porcentaje") {
                              montoDescuento = precioBase * (client?.serviceObj?.montoDescuento / 100);
                            } else if (client?.serviceObj?.tipoDescuento === "Fijo") {
                              montoDescuento = client?.serviceObj?.montoDescuento;
                            }

                            // Restar el descuento del precio base
                            const precioFinal = precioBase - montoDescuento;

                            // Restar el descuento del precio base
                            return `${precioFinal.toFixed(2)} ${client?.serviceObj?.cotizacion.moneda}`;
                          })()}
                        </span>
                      </td>
                    )}

                    {/* Servicio */}
                    <td scope="row" className="px-4 py-2 max-w-[200px] border border-gray-300 truncate text-center">
                      {client.serviceType}
                    </td>

                    {/* Producto */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                      <td scope="row" className="px-4 py-2 w-[200px] border border-gray-300 truncate text-center">
                        <input 
                          type="text"
                          value={client.productos}
                          placeholder="Buzos, comida, maquinaria, etc"
                          className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                          onChange={(e) => handleUpdateText("productos", e.target.value, client.id)}
                        />
                      </td>
                    )}
                    
                    {/* Precio mínimo */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                      <td scope="row" className="px-4 py-2 w-[200px] border border-gray-300 truncate text-center">
                        <input 
                          type="number"
                          value={client.precioMin}
                          placeholder="Precio mínimo"
                          className="w-[10rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                          onChange={(e) => handleUpdateText("precioMin", e.target.value, client.id )}
                        />
                      </td>
                    )}
                    
                    {/* Ticket? */}
                    {(user.area.toUpperCase() === "COMERCIAL" || user.area.toUpperCase() === "ADMINISTRACION" || user.puesto.toUpperCase() === "JEFE DE MARKETING") && (
                      <td scope="row" className="px-4 py-2 w-[200px] border border-gray-300 truncate text-center">
                        <select 
                          type="text"
                          value={client.ticket}
                          className="w-[10rem] text-xs text-gray-700 bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                          onChange={(e) => handleUpdateSelect("ticket", e.target.value, client.id)}
                        >
                          <option value="Seleccionar">Seleccionar</option>
                          <option value="Bajo: -S/.500">Bajo: -S/.500</option>
                          <option value="Normal: S/.800 - S/.3000">Normal: S/.800 - S/.3000</option>
                          <option value="Alto: +S/.5000">Alto: +S/.5000</option>
                        </select>
                      </td>
                    )}

                    {/* Link oficial */}
                    <td scope="row" className="px-4 py-2 max-w-xs border border-gray-300 truncate items-center justify-center text-center">

                      {linkWebOficial ? (
                        <a
                          href={linkWebOficial.url}
                          className="flex items-center justify-center text-blue-500 underline hover:text-blue-700 transition-colors duration-200 block mx-auto text-ellipsis whitespace-nowrap"
                          target="_blank"
                          rel="noopener noreferrer"
                          title={linkWebOficial.url}
                        >
                          <FaLink />
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    
                    {/* Link demo */}
                    <td scope="row" className="px-4 py-2 max-w-xs border border-gray-300 truncate text-center">
                      {linkDemo ? (
                        <a
                          href={linkDemo.url}
                          className="flex items-center justify-center text-blue-500 underline hover:text-blue-700 transition-colors duration-200 block mx-auto text-ellipsis whitespace-nowrap"
                          target="_blank"
                          rel="noopener noreferrer"
                          title={linkDemo.url}
                        >
                          <FaLink />
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    
                    {/* Link backup */}
                    {(user.puesto.toUpperCase() === "DESARROLLADOR FULL STACK" || user.puesto.toUpperCase() === "GERENTE GENERAL" || user.puesto.toUpperCase() === "DESARROLLADOR DE WORDPRESS Y CMS") && (
                      <td scope="row" className="px-4 py-2 border border-gray-300 max-w-xs truncate text-center">
                        {linkBackup ? (
                          <a
                            href={linkBackup.url}
                            className="flex items-center justify-center text-blue-500 underline hover:text-blue-700 transition-colors duration-200 block mx-auto text-ellipsis whitespace-nowrap"
                            target="_blank"
                            rel="noopener noreferrer"
                            title={linkBackup.url}
                          >
                            <FaLink />
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    )}

                  </tr>
                )
              })}

            </tbody> 
          </table>
          )
        )}
      </div>

      {/* Paginador */}
      <PaginationItem
        actualDocs={clients.length}
        totalDocs={totalDocs}
        entity={"clientes"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />

    </div>
  )
}

export default RedesClientesWebs